import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CustomerTargetUrlService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/customertargeturls`;

  constructor(private http: HttpClient) { }

  withUnderPerformingKeywords(customerId: number, taskId: number): Observable<Boo.Objects.CustomerTargetUrl[]> {
    return this.http.post<Boo.Objects.CustomerTargetUrl[]>(`${this.baseUrl}/WithUnderPerformingKeywords`, {
        customerId: customerId,
        taskId: taskId
    });
  }
}
